module.exports = __webpack_public_path__ + "img/go-koenen-min.eab42a55.jpg";